<template>
    <div class="container-fluid justify-content-center">
        <div class="col-md-6 mx-auto">
            <div class="card card-default">
                <div class="card-header text-center">Processing payment</div>

                <div class="card-body text-center">
                    <h2>👏</h2>
                    <div>
                        Thanks for your support. <br />We are processing your payment now.
                    </div>
                    <router-link to="/account" class="btn btn-primary btn-lg mx-auto mt-5">Go back to your account</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => ({

        }),
    }
</script>
